module.exports = __webpack_public_path__ + "static/img/13-03.648af5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/award/13-03.png
// module id = dna8
// module chunks = 1